<template>
  <div v-if="showComponent">
    <!-- ******** DO YOU KNOW THE PERPETRATOR? ********* -->
    <div class="control">
      <h3 v-html="getLabel" />

      <Field
        name="question-known-perpetrator"
        v-slot="{ field, meta }"
        :rules="{
          required:
            vueModel.CreateClaimEntity.ProductSpecific.KnownPerpetrator === undefined ||
            vueModel.CreateClaimEntity.ProductSpecific.KnownPerpetrator === null
        }"
        v-model="vueModel.CreateClaimEntity.ProductSpecific.KnownPerpetrator"
      >
        <RadioGroupStacked
          v-bind="field"
          :options="stepModel.ProductSpecific.KnownPerpetratorOptions"
          :model-value="vueModel.CreateClaimEntity.ProductSpecific.KnownPerpetrator"
        />
        <ValidationError
          :name="field.name"
          :overrides="{ required: 'Angiv venligst' }"
          :errors="errors"
        />
      </Field>
    </div>

    <!-- ******** DO YOU HAVE THE CONTACT INFORMATION? ********* -->
    <div v-if="vueModel.CreateClaimEntity.ProductSpecific.KnownPerpetrator" class="control">
      <h3 v-html="contentModel.LabelAndTooltipKnownPerpetratorContactQuestion" />

      <Field
        name="question-have-perpetrator"
        v-slot="{ field, meta }"
        :rules="{
          required:
            vueModel.CreateClaimEntity.ProductSpecific.HavePerpetratorContactInformation === null
        }"
        v-model="vueModel.CreateClaimEntity.ProductSpecific.HavePerpetratorContactInformation"
      >
        <RadioGroupStacked
          v-bind="field"
          :options="stepModel.ProductSpecific.HavePerpetratorContactInformationOptions"
          :model-value="
            vueModel.CreateClaimEntity.ProductSpecific.HavePerpetratorContactInformation
          "
        />
        <ValidationError
          :name="field.name"
          :overrides="{ required: 'Angiv venligst' }"
          :errors="errors"
        />
      </Field>
    </div>

    <!-- ******** ADD PERPETRATOR CONTACT INFORMATION? ********* -->
    <article
      v-show="vueModel.CreateClaimEntity.ProductSpecific.HavePerpetratorContactInformation"
      id="AddPerpetrator"
      class="extra-margin-bottom"
    >
      <h3 v-html="contentModel.TitlePerpetrator" />
      <!-- ************ PERSON NAME     ************* -->
      <div class="control">
        <label
          for="perpetrator-first-name"
          class="text-question"
          v-html="contentModel.LabelAndTooltipPerpetratorFirstName"
        />
        <input
          id="perpetrator-first-name"
          v-model="vueModel.CreateClaimEntity.ProductSpecific.Perpetrator.FirstName"
          type="text"
          name="perpetrator-first-name"
          :label="contentModel.ErrorMessagePerpetratorFirstName"
        />
        <ValidationError name="perpetrator-first-name" />
      </div>
      <!-- ************ LAST NAME       ************* -->
      <div class="control">
        <label
          for="perpetrator-last-name"
          class="text-question"
          v-html="contentModel.LabelAndTooltipPerpetratorLastName"
        />
        <Field
          id="perpetrator-last-name"
          v-model="vueModel.CreateClaimEntity.ProductSpecific.Perpetrator.LastName"
          type="text"
          name="perpetrator-last-name"
          :label="contentModel.ErrorMessagePerpetratorLastName"
        />
        <ValidationError name="perpetrator-last-name" />
      </div>
      <!-- ************ ADDRESS         ************* -->
      <div class="control">
        <label
          for="perpetrator-address"
          class="text-question"
          v-html="contentModel.LabelAndTooltipPerpetratorAddress"
        />
        <Field
          v-slot="{ field }"
          name="perpetrator-address"
          :label="vueModel.ContentViewModel.Step2Car.ErrorMessageOtherDriverAddressSearch"
          key="perpetrator-address"
          ref="perpetrator-address"
        >
          <address-search
            v-bind="field"
            :model-value="vueModel.CreateClaimStep2Model.SelectedAddress"
            @update:model-value="(newValue) => { vueModel.CreateClaimStep2Model.SelectedAddress = newValue; emit(); }"
            :errors="errors"
          />
          <ValidationError :name="field.name" />
        </Field>
      </div>
      <!-- ************ PHONE AND EMAIL ************* -->
      <div class="control">
        <div class="row">
          <div class="small-12 medium-4 columns">
            <label
              for="perpetrator-phone"
              class="text-question"
              v-html="contentModel.LabelAndTooltipPerpetratorPhone"
            />
            <Field
              id="perpetrator-phone"
              v-model="vueModel.CreateClaimEntity.ProductSpecific.Perpetrator.Phone"
              :rules="{ numeric: true, min: 8 }"
              name="perpetrator-phone"
              type="tel"
              maxlength="8"
              :label="contentModel.ErrorMessagePerpetratorPhone"
            />
            <ValidationError name="perpetrator-phone" />
          </div>
          <div class="small-12 medium-8 columns">
            <label
              for="perpetrator-email"
              class="text-question"
              v-html="contentModel.LabelAndTooltipPerpetratorEmail"
            />
            <Field
              id="perpetrator-email"
              v-model="vueModel.CreateClaimEntity.ProductSpecific.Perpetrator.Email"
              :rules="{ email: true }"
              name="perpetrator-email"
              type="email"
              :label="contentModel.ErrorMessagePerpetratorEmail"
            />
            <ValidationError name="perpetrator-email" />
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import ValidationError from '@/components/UI/ValidationError.vue';
import AddressSearch from '@/components/UI/AddressSearch.vue';
import ReportClaimMixin from '@/components/Feature/Claims/flows/ReportClaimMixin.vue';

export default {
  name: 'AddPerpetrator',
  components: { ValidationError, AddressSearch },
  mixins: [ReportClaimMixin],
  // inject: ['$validator'],
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    },
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    contentModel: {
      type: Object,
      default() {
        return {};
      }
    },
    stepModel: {
      type: Object,
      default() {
        return {};
      }
    },
    countryCode: {
      type: Number,
      default() {
        return null;
      }
    },
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      showComponent: false,
      selectedAddress: null,
      address: {
        ContactAddressId: null,
        Id: null,
        Street: null,
        HouseNumber: null,
        Floor: null,
        Designation: null,
        District: null,
        PostalCode: null,
        City: null,
        CountryRef: null,
        CountryName: null,
        CountryCode: this.countryCode,
        IsForeignAddress: null,
        Locality: null
      }
    };
  },
  computed: {
    getLabel() {
      let str = '';
      const claimType = this.vueModel.CreateClaimStep2Model.DamageCodeForTitleSelection;
      switch (claimType) {
        case 1:
        case 39:
        case 40:
        case 41:
        case 42:
          str = this.contentModel.LabelAndTooltipKnownPerpetratorSuddenQuestion;
          break;
        case 4:
          str = this.contentModel.LabelAndTooltipKnownPerpetratorVandalismQuestion;
          break;
        case 5:
          str = this.contentModel.LabelAndTooltipKnownPerpetratorTheftQuestion;
          break;
        case 43:
          str = this.contentModel.LabelAndTooltipKnownPerpetratorVandalismQuestion;
          break;
        case 44:
        case 45:
        case 46:
        case 47:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
        case 58:
          str = this.contentModel.LabelAndTooltipKnownPerpetratorOtherQuestion;
          break;

        default:
          str = 'No title';
          break;
      }
      return str;
    }
  },
  mounted() {
    if (
      this.vueModel === null ||
      this.contentModel === null ||
      this.stepModel === null ||
      this.countryCode === null
    ) {
      return;
    }

    this.showComponent = true;
  },
  methods: {
    emit() {
      this.updateAddress(this.address, this.vueModel.CreateClaimStep2Model.SelectedAddress);
      this.$emit('update:modelValue', {
        FirstName: this.vueModel.CreateClaimEntity.ProductSpecific.Perpetrator.FirstName,
        LastName: this.vueModel.CreateClaimEntity.ProductSpecific.Perpetrator.LastName,
        Address: this.address,
        Phone: this.vueModel.CreateClaimEntity.ProductSpecific.Perpetrator.Phone,
        Email: this.vueModel.CreateClaimEntity.ProductSpecific.Perpetrator.Email
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.extra-margin-bottom {
  margin-bottom: rem-calc(30px);
}
</style>
